import React from 'react';
import PropTypes from 'prop-types';
import log from 'core/libs/logger';
import cx from 'classnames';
import {
  compose,
  withStateHandlers,
  withPropsOnChange,
  setPropTypes,
} from 'recompose';
import Complete from 'modules/common/Svg/Complete';
import LeftArrow from 'modules/common/Svg/LeftArrow';
import StepIcon from 'modules/common/Svg/StepIcon';
import StepWrapper from './StepWrapper';

const INACTIVE_COLOR = '#a8a8a8';
const ACTIVE_COLOR = '#494949';
const COMPLETED_COLOR = '#61cb91';

const StepLine = ({step = {}, color, Icon, current, isLocked, subscription, ...rest}) => {
  const {name, ctype} = step;
  const accessible = subscription === 'ACTIVE';
  if (ctype === 'step') {
    log('Corrupted step !!', {
      step,
      currentUrl: typeof window !== 'undefined' && window.location.href,
    });
    return null;
  }
  return (
    <StepWrapper step={step} accessible={accessible} {...rest}>
      <div className="dib">
        <div className="flex items-center pa2">
          <div>
            <Icon
              color={color}
              height="23px"
              width="23px"
              type={isLocked && !accessible ? 'locked' : ctype}
              className="ml2 self-center"
            />
          </div>
          <h3 className={cx('pr3 f5', {b: current})} style={{color}}>
            {name || rest.name}
          </h3>
        </div>
      </div>
    </StepWrapper>
  );
};

StepLine.propTypes = {
  color: PropTypes.string.isRequired,
  current: PropTypes.bool.isRequired,
  Icon: PropTypes.func.isRequired,
  step: PropTypes.object,
  isLocked: PropTypes.bool.isRequired,
};

const enhance = compose(
  withStateHandlers(
    {hover: false},
    {
      handleMouseEnter: () => () => ({hover: true}),
      handleMouseLeave: () => () => ({hover: false}),
    },
  ),

  setPropTypes({
    hover: PropTypes.bool.isRequired,
    stepProgress: PropTypes.string.isRequired,
  }),

  withPropsOnChange(
    ['current', 'hover', 'stepProgress','isLocked', 'subscription'],
    ({current, hover, stepProgress, isLocked, subscription}) => {
      let Icon = StepIcon;
      let color = INACTIVE_COLOR;
      if (stepProgress === 'completed' && !isLocked) {
        color = COMPLETED_COLOR;
        if (!hover) {
          Icon = Complete;
        }
      } else if (current && (!isLocked || subscription === 'ACTIVE')) {
        color = ACTIVE_COLOR;
      }

      if (current && (!isLocked || subscription === 'ACTIVE')) {
        Icon = LeftArrow;
      }
      return {
        color,
        Icon,
      };
    },
  ),
);
export default enhance(StepLine);
